import { Helmet } from "react-helmet-async"
import { CreditConsumptionView } from "../../../SubscriptionWalletCredits"

export default function CreditConsumptionAllPage() {
	return (
		<>
			<Helmet>
				<title>All Credit Consumptions</title>
			</Helmet>
			<CreditConsumptionView />
		</>
	)
}
